module.exports = __webpack_public_path__ + "static/media/dm_logo_30_anios_h.18598694.webp";